module.exports = __webpack_public_path__ + "img/streaming.4c03a3b4.svg";